import {Component, OnInit} from '@angular/core';
import {AttractionsService} from '../../../services/attractions.service';
import {UtilsService} from '../../../services/utils.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-new-attraction',
  templateUrl: './new-attraction.component.html',
  styleUrls: ['./new-attraction.component.scss']
})
export class NewAttractionComponent implements OnInit {

  attraction = {
    name: ''
  };

  constructor(private attractionsService: AttractionsService,
              private utilsService: UtilsService,
              private router: Router) {
  }

  ngOnInit() {
  }

  createAttraction() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.attraction.name);
    if (requiredSuccess) {
      this.attractionsService.createAttraction(this.attraction).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Attraction Created !!', '');
          this.router.navigate(['/attractions']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create attraction.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/attractions/new-attraction/new-attraction.component.ts